import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { analyticsChartTheme } from 'util/chartUtils';
import CardBox from '../../../../components/kea/CardBox';
import DashboardStub from '../../../../components/kea/DashboardStub';
import ButtonGrp from '../../../../components/kea/ButtonGrp';
import IntlMessages from 'util/IntlMessages';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

function Profitability({ chart }) {
  const t = useLocalizedMessage();
  const barIsWeekly = (chart.daily && !chart.error) ? (chart.daily.money.curve.length > 25) : false;
  const [weeklyBar, toggleBarType] = useState(barIsWeekly);

  const barOptions = {
    legend: {
      position: 'bottom',
    },
    tooltips: {
      mode: 'index',
      intersect: false,
    },
    responsive: true,
    scales: {
      xAxes: [{
        stacked: true,
      }],
      yAxes: [{
        stacked: true,
      }],
    },
  };

  function prepareData(raw) {
    const result = {
      labels: [],
      datasets: [
        {
          label: t('ui.recs.dashboard.profitability.baseIncome'),
          backgroundColor: analyticsChartTheme.grid,
          data: [],
        }, {
          label: t('ui.recs.dashboard.profitability.additionalIncomeFromRecommendations'),
          backgroundColor: analyticsChartTheme.brand,
          data: [],
        }],
    };
    raw.forEach((e) => {
      result.labels.push(e.date);
      result.datasets[0].data.push(e.noRec.toFixed(0));
      result.datasets[1].data.push(e.rec.toFixed(0));
    });

    return result;
  }

  if (chart.error || !chart.weekly || !chart.daily) {
    return (
      <CardBox header={t('recs.dashboard.profitability.title')} styleName="recs-dashboard-card">
        <DashboardStub />
      </CardBox>
    );
  }

  const { money } = weeklyBar ? chart.weekly : chart.daily;
  const data = prepareData(money.curve);
  const actionComponent = <ButtonGrp value={weeklyBar} buttons={[{ value: true, text: t('recs.dashboard.period.weekly') }, { value: false, text: t('recs.dashboard.period.daily') }]} onClick={toggleBarType} />;

  return (
    <CardBox
      header={t('recs.dashboard.profitability.title')}
      styleName="recs-dashboard-card"
      subheader={t('recs.dashboard.profitability.description')}
      subsubheader=<IntlMessages id="ui.recs.dashboard.profitability.noteChartDoesnTRepresentStateOfCartsAsKeaLabs" />
      actionComponent={actionComponent}
    >
      <div className="row">
        <div className="col-12">
          <Bar data={data} options={barOptions} height={140} />
        </div>
      </div>

    </CardBox>
  );
}

Profitability.propTypes = {
  chart: PropTypes.shape({
    weekly: PropTypes.shape({
      money: PropTypes.shape({
        curve: PropTypes.arrayOf(PropTypes.shape({
          noRec: PropTypes.any,
          rec: PropTypes.any,
        })),
      }),
    }),
    daily: PropTypes.shape({
      money: PropTypes.shape({
        curve: PropTypes.arrayOf(PropTypes.shape({
          noRec: PropTypes.any,
          rec: PropTypes.any,
        })),
      }),
    }),

    error: PropTypes.any,
  }).isRequired,
};

export default Profitability;
